import { Component, OnInit, Input, OnDestroy, EventEmitter, Output, ViewChild, AfterViewInit } from '@angular/core';
import { NewTripComponent } from '../../component/assigned-trips/new-trip/new-trip.component';
import { AssigTripsService } from '../../component/assigned-trips/assigntrips-service/assigntrips-service';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';
import { Events } from 'src/app/utils/event-utils';
import { SocketService } from 'src/app/service/socket-service/socket-service.service';
import { sweetAlert } from 'src/app/utils/swal';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-edit-trip-modal',
  templateUrl: './edit-trip-modal.component.html',
  styleUrls: ['./edit-trip-modal.component.css']
})
export class EditTripModalComponent implements OnInit,AfterViewInit, OnDestroy {
  @ViewChild('tripComponent', { static: false }) tripComponent: NewTripComponent;
  @Input() tripId: any;
  @Input() trip?: any;
  @Output() onCloseModal = new EventEmitter<string>();
  @Output() onUpdate = new EventEmitter<string>();

   renderOptions = {
    suppressMarkers: true,
  
  };

  directions = {
    origin : { lat: 0.00000, lng: 0.00000 },
    destination : { lat: 0.00000, lng: 0.00000 }
  }
  origin = { lat: 0.00000, lng: 0.00000 };
  destination = { lat: 0.00000, lng: 0.00000 };
  driverLoc = { lat: 0.00000, lng: 0.00000 };

  isShowCancel = false;
  drivers = [];
  driverIndex = -1;
  selectedDriver;
  searchDriver = '';
  preLevelOfServices = {};
  preSpaceTypes:any = {};
  isAllowRoute = false;

  constructor(private assignTripService: AssigTripsService,
    private socketService: SocketService) { }


  ngOnInit() {

    this.listenSocket();
    if (this.trip) {
      this.origin = {
        lat: this.trip.jobOriginLatitude,
        lng: this.trip.jobOriginLongitude
      };

      this.destination = {
        lat: this.trip.jobDestinationLatitude,
        lng: this.trip.jobDestinationLongitude
      };

      this.directions.origin = this.origin;
      this.directions.destination = this.destination;

      if (this.trip.driver) {
        if (typeof this.trip.driver === 'string') {
          this.selectedDriver = this.trip.driver;
        } else {
          this.selectedDriver = this.trip.driver._id;
        }
      }
    }

    if (this.trip) {
      this.getNearbyDriver();
    }
  }

  ngAfterViewInit(): void {

    this.tripComponent.newTripForm.controls['jobOriginLatitude'].valueChanges.pipe(takeUntil(componentDestroyed(this))).subscribe(
      (lat) => {
          this.origin.lat = lat
      }
    );

    this.tripComponent.newTripForm.controls['jobOriginLongitude'].valueChanges.pipe(takeUntil(componentDestroyed(this))).subscribe(
      (lng) => {
        this.origin.lng = lng
      }
    );


    this.tripComponent.newTripForm.controls['jobDestinationLatitude'].valueChanges.pipe(takeUntil(componentDestroyed(this))).subscribe(
      (lat) => {
          this.destination.lat = lat
      }
    );

    this.tripComponent.newTripForm.controls['jobDestinationLongitude'].valueChanges.pipe(takeUntil(componentDestroyed(this))).subscribe(
      (lng) => {
        this.destination.lng = lng
      }
    );

  }

  listenSocket() {
    this.socketService.addListener(Events.GET_DRIVER_MILES_FOR_ASSIGN_MODAL)
    .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data.success) {
          this.drivers[this.driverIndex].googleETA = data.message;
        } else {
          this.drivers[this.driverIndex].googleETA = null;
        }
      });

    this.socketService.addListener(Events.UPDATE_ASSIGN_TRIP)
    .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data.success) {
          // sweetAlert('Success', data.message, 'success', 'OK');
          if (data.assign) {
            this.trip.isReadyForPickup = data.assign.isReadyForPickup;
            this.trip.isVipTrip = data.assign.isVipTrip;
            this.trip.isConfirmedTrip = data.assign.isConfirmedTrip;
            this.trip.isVoiceMail = data.assign.isVoiceMail;
          }
        } else {
          sweetAlert('Error', data.message, 'warning', 'OK');
        }
      });
  }

  getNearbyDriver() {
    let data: any = {}
      data = {
        jobOriginLatitude: this.trip.jobOriginLatitude,
        jobOriginLongitude: this.trip.jobOriginLongitude,
        fundingSource: this.trip.cooperate,
        spaceType: this.trip.spaceType,
        scheduleTime: this.trip.scheduleTime,
        isNearBy: true,
        loadTime: this.preSpaceTypes[this.trip.spaceType].loadTime,
        unloadTime: this.preSpaceTypes[this.trip.spaceType].unloadTime,
        milage: this.trip.milage,
        jobDestinationLatitude: this.trip.jobDestinationLatitude,
        jobDestinationLongitude: this.trip.jobDestinationLongitude,
        appointmentTime: this.trip.appointmentTime,
      };

      if (this.trip.serviceArea) {
        data.serviceArea = this.trip.serviceArea
      }
      }

  getMiles(driverIndex, driver) {
    this.driverIndex = -1;

    if (this.trip.jobOriginLatitude && this.trip.jobOriginLongitude && this.trip.jobDestinationLatitude && this.trip.jobDestinationLongitude) {
      const payload = {
        origin: this.trip.jobOriginLatitude + ' , ' + this.trip.jobOriginLongitude,
        destination: driver.coords[1] + ' , ' + driver.coords[0]
        // destination: vm.assign.jobDestinationLatitude + ' , ' + vm.assign.jobDestinationLongitude
      };
      payload['dbMiles'] = driver.miles || 0;
      payload['isLog'] = true;
      this.driverIndex = driverIndex;
      this.socketService.emit(Events.GET_DRIVER_MILES_FOR_ASSIGN_MODAL, payload);
    } else {
      sweetAlert('Alert', 'Please Select Pickup and DropOff Address', 'warning', 'OK');
    }
  }

  onUpdateTrip(event) {
    this.onUpdate.emit(event);
  }

  saveTrip() {

    if (this.selectedDriver) {
      this.tripComponent.newTripForm.patchValue({
        driver: this.selectedDriver,
        status : 'offered',
        jobStatus : 'offered',
      })
    }

    this.tripComponent.onCreateTrip();
  }

  cancelTrip() {
     this.isShowCancel = true;
  }

  unAssign() {
    this.trip.status = 'unassigned';
    this.trip.jobStatus = 'pending';
    this.updateTrip(this.trip);
  }

  archive() {
    this.trip.status = 'archived';
    this.updateTrip(this.trip);
  }

  updateTrip(payload) {
    this.assignTripService
      .updateTrip(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.onUpdate.emit(data);
        }
      });
  }

  updateJob() {
    let params = {
      assignId: this.trip._id
    }
    params['isReadyForPickup'] = !this.trip['isReadyForPickup'];
    this.socketService.emit(Events.UPDATE_ASSIGN_TRIP, params);
  }

  onSelectDriver(driver) {
    this.selectedDriver = driver._id;
    this.driverLoc = {
      lat: driver.coords[1],
      lng: driver.coords[0]
    };
  }

  closeModal() {
    this.onCloseModal.emit();
  }

  closeCancelModal(event) {
    this.isShowCancel = false;
    this.onUpdate.emit(event);
  }

  ngOnDestroy(): void {
  }
}
